export const ACTION_SEEN = "ACTION_SEEN";
export const ACTION_DONE = "ACTION_DONE";
export const ACTION_DONE_REQUEST = "ACTION_DONE_REQUEST";
export const ACTION_SET = "ACTION_SET";
export const ACTION_GET_NEW_ONE_REQUEST = "ACTION_GET_NEW_ONE_REQUEST";
export const ACTION_GET_NEW_ONE_SUCCESS = "ACTION_GET_NEW_ONE_SUCCESS";
export const ACTION_GET_NEW_ONE_ERROR = "ACTION_GET_NEW_ONE_ERROR";
export const ACTION_UNSET = "ACTION_UNSET";
export const ACTION_UNSEEN = "ACTION_UNSEEN";
export const ACTION_SET_NEXT = "ACTION_SET_NEXT";
export const ACTION_DONE_PERCENTAGE_CHANGE = "ACTION_DONE_PERCENTAGE_CHANGE";
export const ACTION_NEXT_CATEGORY_CHANGE = "ACTION_NEXT_CATEGORY_CHANGE";
export const ACTION_COMMENT_CHANGE = "ACTION_COMMENT_CHANGE";
export const ACTION_RATING_CHANGE = "ACTION_RATING_CHANGE";
export const ACTION_FEEDBACK_SUBMIT = "ACTION_FEEDBACK_SUBMIT";
export const ACTION_FEEDBACK_SUBMIT_REQUEST = "ACTION_FEEDBACK_SUBMIT_REQUEST";
export const ACTION_FEEDBACK_ACTION_DONE_CHANGE =
  "ACTION_FEEDBACK_ACTION_DONE_CHANGE";
export const ACTION_FEEDBACK_ERROR = "ACTION_FEEDBACK_ERROR";
export const ACTION_LOGIN_SEEN = "ACTION_LOGIN_SEEN";
export const ACTION_GET_ADMIN_REQUEST = "ACTION_GET_ADMIN_REQUEST";
export const ACTION_CANT_DO_REQUEST = "ACTION_CANT_DO_REQUEST";
export const ACTION_SELECT_NEXT_CATEGORY = "ACTION_SELECT_NEXT_CATEGORY";
export const ACTION_CHANGE = "ACTION_CHANGE";

export const ACTION_FEEDBACK_SHARED_STATE = "ACTION_FEEDBACK_SHARED_STATE";
export const ACTION_FEEDBACK_SHARED_STATE_RESET =
  "ACTION_FEEDBACK_SHARED_STATE_RESET";

export const CHANGE_SEE_ACTION_AGAIN = "action/CHANGE_SEE_ACTION_AGAIN";

export const CHANGE_ANALYSIS_TYPE = "action/CHANGE_ANALYSIS_TYPE";
